export default __webpack_public_path__ + "static/media/background_min.c3ade3c2.svg";